/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_MetalInputs */

const en_field_metal = /** @type {(inputs: Field_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metal / Base`)
};

const es_field_metal = /** @type {(inputs: Field_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metal / Base`)
};

const fr_field_metal = /** @type {(inputs: Field_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métal / Base`)
};

const de_field_metal = /** @type {(inputs: Field_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metall / Basis`)
};

const ja_field_metal = /** @type {(inputs: Field_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`金属 / ベース素材`)
};

const zh_field_metal = /** @type {(inputs: Field_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`金属 / 基底`)
};

const ar_field_metal = /** @type {(inputs: Field_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المعدن / القاعدة`)
};

const id_field_metal = /** @type {(inputs: Field_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logam / Dasar`)
};

const it_field_metal = /** @type {(inputs: Field_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metallo / Base`)
};

const ru_field_metal = /** @type {(inputs: Field_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Металл / Основа`)
};

const pt_field_metal = /** @type {(inputs: Field_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metal / Base`)
};

const ko_field_metal = /** @type {(inputs: Field_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`금속 / 베이스`)
};

/**
* | output |
* | --- |
* | "Metal / Base" |
*
* @param {Field_MetalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_metal = /** @type {((inputs?: Field_MetalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_MetalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_metal(inputs)
	if (locale === "es") return es_field_metal(inputs)
	if (locale === "fr") return fr_field_metal(inputs)
	if (locale === "de") return de_field_metal(inputs)
	if (locale === "ja") return ja_field_metal(inputs)
	if (locale === "zh") return zh_field_metal(inputs)
	if (locale === "ar") return ar_field_metal(inputs)
	if (locale === "id") return id_field_metal(inputs)
	if (locale === "it") return it_field_metal(inputs)
	if (locale === "ru") return ru_field_metal(inputs)
	if (locale === "pt") return pt_field_metal(inputs)
	return ko_field_metal(inputs)
});